(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsq-cart-upsell"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dialog = root.querySelector('dialog');
      const form = root.querySelector('[data-upsell-form]');
      const submitButton = form?.querySelector('[type="submit"]');
      const errorMessage = root.querySelector('[data-upsell-error]');
      const showOnce = root.dataset.showOnce === 'true';
      const storageKey = root.dataset.storageKey;
      const delay = Number(root.dataset.delay || 0);

      if (!dialog || !form || !submitButton) return;

      const rememberDismissal = () => {
        if (!showOnce) return;
        try {
          sessionStorage.setItem(storageKey, 'dismissed');
        } catch (error) {
          return;
        }
      };

      const closeDialog = () => {
        rememberDismissal();
        dialog.close();
      };

      root.querySelectorAll('[data-upsell-close]').forEach((button) => {
        button.addEventListener('click', closeDialog);
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });

      dialog.addEventListener('cancel', rememberDismissal);

      form.addEventListener('submit', async (event) => {
        if (!window.fetch) return;
        event.preventDefault();
        submitButton.disabled = true;
        submitButton.textContent = submitButton.dataset.labelAdding;
        errorMessage.hidden = true;

        try {
          const response = await fetch(form.dataset.ajaxUrl, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });

          if (!response.ok) throw new Error('Cart request failed');
          submitButton.textContent = submitButton.dataset.labelAdded;
          window.location.reload();
        } catch (error) {
          submitButton.disabled = false;
          submitButton.textContent = submitButton.dataset.labelDefault;
          errorMessage.hidden = false;
        }
      });

      let dismissed = false;
      if (showOnce) {
        try {
          dismissed = sessionStorage.getItem(storageKey) === 'dismissed';
        } catch (error) {
          dismissed = false;
        }
      }

      if (!dismissed) {
        window.setTimeout(() => dialog.showModal(), delay);
      }
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-tsq-upsell]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
